import firebase from "firebase/app";

import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC7DOhiC4FI2MZHXHY02Pmixm78NwsBCdo",
  authDomain: "ziqin-you-tube-clone.firebaseapp.com",
  projectId: "ziqin-you-tube-clone",
  storageBucket: "ziqin-you-tube-clone.appspot.com",
  messagingSenderId: "954304386297",
  appId: "1:954304386297:web:d278771ce7ade4c859be28",
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();

export { auth };
